module.exports = __webpack_public_path__ + "img/141-05922e.png";